module.exports = __webpack_public_path__ + "img/logo.377056c7.png";